var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 79,
    viewBox: "0 0 72 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 32C44.0343 32 50.75 25.2843 50.75 17C50.75 8.71573 44.0343 2 35.75 2C27.4657 2 20.75 8.71573 20.75 17C20.75 25.2843 27.4657 32 35.75 32Z",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 77C69.5 58.3606 54.3894 43.25 35.75 43.25C17.1106 43.25 2 58.3606 2 77",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 77L43.25 67.625L35.75 43.25L28.25 67.625L35.75 77Z",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBc);
export default __webpack_public_path__ + "static/media/BC.d10f42435d6f0ef2969d3c011eb1814e.svg";
export { ForwardRef as ReactComponent };